"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var operators_1 = require("rxjs/operators");
var HttpPortfolioDefinitionsService = /** @class */ (function () {
    function HttpPortfolioDefinitionsService(applicationPropertiesService) {
        this.applicationPropertiesService = applicationPropertiesService;
    }
    HttpPortfolioDefinitionsService.prototype.loadPortfolioDefinitions = function () {
        if (!this.portfolioDefinitions$) {
            this.portfolioDefinitions$ = Observable_1.Observable.fromPromise(this.applicationPropertiesService.loadProjectConfigs())
                .pipe(operators_1.map(function (value) {
                return value['portfolioDefinitions'] ? JSON.parse(value['portfolioDefinitions']) : {};
            }), operators_1.shareReplay(1));
        }
        return this.portfolioDefinitions$;
    };
    // ToDo: load some basic portfolio even if no portfolio defined
    HttpPortfolioDefinitionsService.prototype.loadDefaultPortfolioDefinitionByCategory = function (categoryId) {
        return this.loadPortfolioDefinitions().pipe(operators_1.map(function (portfolioDefinitions) {
            return portfolioDefinitions && portfolioDefinitions[categoryId] ? portfolioDefinitions[categoryId][0] : null;
        }));
    };
    HttpPortfolioDefinitionsService.prototype.loadPortfolioDefinitionById = function (id, categoryId) {
        return this.loadPortfolioDefinitions().pipe(operators_1.map(function (portfolioDefinitions) {
            return portfolioDefinitions && portfolioDefinitions[categoryId] ?
                portfolioDefinitions[categoryId].find(function (portfolioDefinition) { return portfolioDefinition.id === id; }) : null;
        }));
    };
    HttpPortfolioDefinitionsService.prototype.loadPortfolioDefinitionsByCategory = function (categoryId) {
        return this.loadPortfolioDefinitions().pipe(operators_1.map(function (portfolioDefinitions) { return portfolioDefinitions && portfolioDefinitions[categoryId] ? portfolioDefinitions[categoryId].slice() : []; }));
    };
    HttpPortfolioDefinitionsService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpPortfolioDefinitionsService);
    return HttpPortfolioDefinitionsService;
}());
exports.HttpPortfolioDefinitionsService = HttpPortfolioDefinitionsService;
//# sourceMappingURL=http-portfolio-definitions.service.js.map